import { ANIMAL } from './animal.config';
import { CAR } from './car.config';
import { BOAT } from './boat.config';
import { DENTAL } from './dental.config';
import { HOUSE } from './house.config';
import { RENT_HOUSE } from './rent-house.config';
import { HOUSE_ROT } from './house-rot.config';
import { CONTENTS } from './contents.config';
import { VACATION_HOME } from './vacation-home.config';
import { TRAVEL } from './travel.config';
import { MOTORCYCLE } from './motorcycle.config';
import { MOPED } from './moped.confg';
import { MOBILE_HOME } from './mobile-home.config';
import { TRAILER_HOME } from './trailer-home.config';
import { VALUABLES } from './valuables.config';
import { VACATION_HOME_ABROAD } from './vacation-home-abroad.config';
import { TRACTOR } from './tractor.config';
import { ILLNESS } from './illness.config';
import { CRITICAL_ILLNESS } from './critical-illness.config';
import { INCOME_ACCIDENT } from './income-accident.config';
import { ACCIDENT } from './accident.config';
import { INCOME } from './income.config';
import { VETERAN_CAR } from './veteran-car.config';
import { SNOWMOBILE } from './snowmobile.config';
import { POLICY } from './policy.config';
import { PENSION } from './pension.config';
import { RENTAL } from './rental.config';
import { CHILD } from './child.config';
import { CHILDREN } from './children.config';
import { LIFE } from './life.config';
import { HEALTH } from './health.config';
import { NATURSKADE } from './naturskade.config';
import { GREEDY_FEE } from './greedy-fee.config';
import { DEBT } from './debt.confg';
import { UNREGISTERED_MOTO } from './unregistered-moto.config';
import { FEE } from './fee.config';
import { OFFER } from './offer.config';

export const PRODUCTS_MAP_SCOOPR = {
  ANIMAL,
  CAR,
  BOAT,
  DENTAL,
  HOUSE,
  RENT_HOUSE,
  HOUSE_ROT,
  CONTENTS,
  VACATION_HOME,
  TRAVEL,
  MOTORCYCLE,
  MOPED,
  MOBILE_HOME,
  TRAILER_HOME,
  VALUABLES,
  VACATION_HOME_ABROAD,
  TRACTOR,
  ILLNESS,
  CRITICAL_ILLNESS,
  INCOME_ACCIDENT,
  ACCIDENT,
  INCOME,
  VETERAN_CAR,
  SNOWMOBILE,
  POLICY,
  PENSION,
  RENTAL,
  CHILD,
  CHILDREN,
  LIFE,
  HEALTH,
  NATURSKADE,
  GREEDY_FEE,
  DEBT,
  UNREGISTERED_MOTO,
  FEE,
  OFFER
};
